import { render } from "./AdminBoxCaseSettings.vue?vue&type=template&id=158436c4&scoped=true"
import script from "./AdminBoxCaseSettings.vue?vue&type=script&lang=js"
export * from "./AdminBoxCaseSettings.vue?vue&type=script&lang=js"

import "./AdminBoxCaseSettings.vue?vue&type=style&index=0&id=158436c4&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158436c4"]])

export default __exports__